import React from 'react';
import axios from 'axios';

import ChangeDataCase from './CardOfCaseComponents/ChangeDataCase';
import ComplaintsFind from './CardOfCaseComponents/ComplaintsFinder';
import PhasesCase from './CardOfCaseComponents/PhasesCase';
import WorkerCase from './CardOfCaseComponents/WorkerCase';
import AMPanel from './CardOfCaseComponents/AMPanel';
import FilesCase from './CardOfCaseComponents/FilesCase'
import AddNewFileToCase from './CardOfCaseComponents/AddNewFileToCase';
import CommentsCase from './CardOfCaseComponents/CommentsCase';
import AddNewCommentToCase from './CardOfCaseComponents/AddNewCommentToCase';

import { useTimeModal } from './TimeModal/TimeModalContext';
import { formatDate, formatNull, formatDateTime } from '../Utils/GlobalUtils';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const CardOfCase = ({ closeModal, id, onCardOfCaseSuccess, isPage }) => {
    const { openTimeModal } = useTimeModal();

    const [caseInfo, setCaseInfo] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [confirmChangeStatusCase, setConfirmChangeStatusCase] = React.useState(false);
    const [confirmDelete, setConfirmDelete] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [isShowAddNewInfoToCaseBtn, setIsShowAddNewInfoToCaseBtn] = React.useState(false);

    const [isChangeData, setIsChangeData] = React.useState(false);

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-info-case?caseId=${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Ошибка системы.');
                setCaseInfo([]);
            } else {
                setWarning('');
                setCaseInfo((prev) => ({
                    ...prev,
                    ...response.data,
                }));
                document.title = `${response.data.number || response.data.internal_number} — Журнал «Поток»`;
                if (!response.data.number || !response.data.applicant || !response.data.phase_id || !response.data.date_end) {
                    setIsShowAddNewInfoToCaseBtn(true);
                };
            }
        })
        .catch(error => {
            if (error.response?.data.action == 'logout') {
                window.location.href = '/auth/logout';
            }
            setWarning(`Ошибка при загрузке карточки:  ${error.response?.data.message || error.message}`);
            setCaseInfo([]);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, id]);

    const [access, setAccess] = React.useState(false);
    // const [isAccessLoading, setIsAccessLoading] = React.useState(true);
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/get-user-role', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                if (response.data.role == 'Администратор' ||
                    response.data.role == 'Менеджер' ||
                    response.data.role == 'Работник по назначениям' ||
                    response.data.role == 'Работник по жалобам' ||
                    response.data.role == 'Работник по общим') {
                    setAccess(true);
                }
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
            })
            .finally(() => {
                // setIsAccessLoading(false);
            })
        } else {
            handleLogout();
        }
    }, []);

    const deleteCase = (caseId) => {
        try {
            axios.delete(`/api/delete-case?caseId=${caseId}`);
            window.location.reload();
        }
        catch (error) {
            openTimeModal('Ошибка при удалении дела', 'error');
        }
    };
    const handleDeleteClick = (caseId) => {
        if (confirmDelete) {
            deleteCase(caseId);
            setConfirmDelete(false);
        } else {
            setConfirmDelete(true);
        }
    };

    const changeStatusCase = (caseId) => {
        axios.put(`/api/change-status-case?caseId=${caseId}`)
        .then(() => {
            openTimeModal('Статус карточки изменён. Конечная дата установлена на текущий день', 'success');
            setReload(true);
        })
        .catch(() => {
            openTimeModal('Ошибка при изменении статуса карточки', 'error');
        });
    };
    const handleChangeStatusCaseClick = (caseId) => {
        if (confirmChangeStatusCase) {
            changeStatusCase(caseId);
            setConfirmChangeStatusCase(false);
        } else {
            setConfirmChangeStatusCase(true);
        }
    };

    const [shareButtonText, setShareButtonText] = React.useState('Поделиться ссылкой');

    const handleShareClick = () => {
        const link = `https://journalalians.ru/case/${id}`;
        navigator.clipboard.writeText(link).then(() => {
            setShareButtonText('Ссылка на дело скопирована');
            setTimeout(() => setShareButtonText('Поделиться'), 2000);
        }).catch(err => {
            console.error('Ошибка при копировании ссылки:', err);
            setShareButtonText('Ошибка при копировании ссылки: '+err);
        });
    };

    const formatOverdue = (dateEnd, status) => {
        const todayMSC = new Date();
        todayMSC.setHours(todayMSC.getHours() + 3);
    
        if (!dateEnd) {
            return <div className={styles.cardOfCaseLine}>
                    <a className={`${styles.statusCasePanel} ${styles.blue}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="currentColor" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                        Необходимо заполнить карточку
                    </a>
                </div>;
        }
    
        const isPastEndDate =
            new Date(dateEnd) < todayMSC && status !== 'Завершено';
    
        if (isPastEndDate) {
            return  <div className={styles.cardOfCaseLine}>
                    <a className={`${styles.statusCasePanel} ${styles.red}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-triangle"><path fill="currentColor" d="M12,16a1,1,0,1,0,1,1A1,1,0,0,0,12,16Zm10.67,1.47-8.05-14a3,3,0,0,0-5.24,0l-8,14A3,3,0,0,0,3.94,22H20.06a3,3,0,0,0,2.61-4.53Zm-1.73,2a1,1,0,0,1-.88.51H3.94a1,1,0,0,1-.88-.51,1,1,0,0,1,0-1l8-14a1,1,0,0,1,1.78,0l8.05,14A1,1,0,0,1,20.94,19.49ZM12,8a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z"></path></svg>
                        Сроки исполнения текущего этапа были нарушены
                    </a>
                </div>;
        }
    
        return '';
    };

    const getTitle = () => {
        if (loading) {
            return 'Загрузка карточки...';
        }
        if (caseInfo.phaseName === 'Назначение арбитражного управляющего') {
            return 'Карточка заявки';
        }
        if (isChangeData) {
            return 'Изменение информации';
        }
        switch (caseInfo.labelName) {
            case 'Назначения':
                return 'Карточка дела';
            case 'Жалобы':
                return 'Карточка жалобы';
            case 'Общие':
                return 'Карточка письма';
            default:
                return 'Карточка дела';
        }
    };

    return (
    <>
        <div className={styles.liningOver} onClick={!isPage ? () => { closeModal(); onCardOfCaseSuccess(); } : undefined} style={isPage ? { backgroundColor: '#00000000' } : undefined}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
                <h1>
                    {isChangeData && 
                    <svg onClick={() => {setIsChangeData(false)}} viewBox="0 0 24 24">
                        <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                    </svg>}
                    {getTitle()}
                </h1>
                {!isChangeData && !isPage &&
                <svg title='Открыть в новом окне' onClick={() => {window.open(`/case/${caseInfo.id}`, '_blank')}} style={{width: '22px', marginRight: '20px'}} viewBox="0 0 24 24" id="external-link-alt">
                    <path fill="currentColor" d="M18,10.82a1,1,0,0,0-1,1V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V8A1,1,0,0,1,5,7h7.18a1,1,0,0,0,0-2H5A3,3,0,0,0,2,8V19a3,3,0,0,0,3,3H16a3,3,0,0,0,3-3V11.82A1,1,0,0,0,18,10.82Zm3.92-8.2a1,1,0,0,0-.54-.54A1,1,0,0,0,21,2H15a1,1,0,0,0,0,2h3.59L8.29,14.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,5.41V9a1,1,0,0,0,2,0V3A1,1,0,0,0,21.92,2.62Z"></path>
                </svg>}
                {!isChangeData && access &&
                <svg title='Редактировать' onClick={() => {setIsChangeData(true)}} style={{width: '22px', marginRight: '20px'}} viewBox="0 0 24 24" id="pen">
                    <path fill="currentColor" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path>
                </svg>}
                <svg onClick={() => {closeModal(); onCardOfCaseSuccess()}} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                </svg>
            </div>
            <div className={styles.main}>
                {loading ? (
                    <Loading />
                ) : warning ? (
                    <a>{warning}</a>
                ) : (
                    !isChangeData ? (
                    <>
                        {formatOverdue(caseInfo.date_end, caseInfo.status)}

                        <div className={styles.cardOfCaseLine}>
                            <h2>Номер:</h2>
                            <a>{formatNull(caseInfo.number)}</a>
                        </div>
                        {
                        caseInfo.labelName == 'Жалобы' ? ( 
                            <div className={styles.cardOfCaseLine}>
                                <h2>Жалоба на следующее дело:</h2>
                                <a className={styles.aWithLink} onClick={(e) => {e.preventDefault(); window.open(`/case/${caseInfo.toCaseId}`, '_blank');}}>{formatNull(caseInfo.toCaseNumber)}</a>
                            </div>
                        ) : (
                            <ComplaintsFind caseId={caseInfo.id} access={access} />
                        )
                        }
                        <div className={styles.cardOfCaseLine}>
                            <h2>Номер входящей корреспонденции:</h2>
                            <a>{formatNull(caseInfo.internal_number)}</a>
                        </div>
                        {isShowAddNewInfoToCaseBtn && access &&
                            <button type='button' className='button black' onClick={() => {setIsChangeData(true)}}>Заполнить карточку</button>
                        }

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            <h2>Тип карточки:</h2>
                            <a>{caseInfo.labelName}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Категория:</h2>
                            <a>{formatNull(caseInfo.categoryName)}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Текущий этап:</h2>
                            <PhasesCase caseId={id} phaseId={caseInfo.phase_id} dateEndCase={formatDate(caseInfo.date_end)} caseStatus={caseInfo.status} sideReload={reload} />
                            {access && 
                            <div style={{marginTop: '10px'}}>
                                {caseInfo.status=='В работе' ?
                                <button 
                                    type='button' 
                                    className='miniButton maxWidth' 
                                    onClick={() => handleChangeStatusCaseClick(caseInfo.id)}
                                >
                                    {confirmChangeStatusCase ? "Вы уверены, что хотите закрыть карточку?" : "Принудительно закрыть карточку"}
                                </button>
                                :
                                <button 
                                    type='button' 
                                    className='miniButton maxWidth' 
                                    onClick={() => handleChangeStatusCaseClick(caseInfo.id)}
                                >
                                    {confirmChangeStatusCase ? "Вы уверены, что хотите вернуть карточку в работу?" : "Вернуть карточку в работу"}
                                </button>}
                            </div>
                            }
                        </div>

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            <h2>Должник:</h2>
                            <a>{formatNull(caseInfo.applicant)}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Регион:</h2>
                            <a>{formatNull(caseInfo.region)}</a>
                        </div>
                        {access &&
                            <div className={styles.cardOfCaseLine}>
                                <h2>Работник СОАУ:</h2>
                                <WorkerCase caseId={caseInfo.id} workerId={caseInfo.worker_id} statusCase={caseInfo.status} onAppointWorkerForCaseSuccess={() => {setReload(true)}} />
                            </div>
                        }
                        {access &&
                            <div className={styles.cardOfCaseLine}>
                                <AMPanel id={id} workerId={caseInfo.worker_id} mailingStatus={caseInfo.mailing_status} phaseId={caseInfo.phase_id} userDetails={caseInfo.userDetails} dateCourt={caseInfo.date_court} dateSubmissionCandidate={caseInfo.date_submission_candidate} dateAmAppointment={caseInfo.date_am_appointment} onAMPanelSuccess={() => {setReload(true)}} />
                            </div>
                        }
                        {!caseInfo.date_am_appointment &&
                            <div className={styles.cardOfCaseLine}>
                                <h2>Дата судебного заседания:</h2>
                                <a>{formatDate(caseInfo.date_court)}</a>
                            </div>
                        }

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            <h2>Комментарии:</h2>
                            <CommentsCase caseId={id} access={access} onCommentsSuccess={() => {setReload(true)}} sideReload={reload} />
                            <AddNewCommentToCase caseId={id} access={access} onNewCommentSuccess={() => {setReload(true)}} />
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Файлы:</h2>
                            <FilesCase caseId={id} access={access} onFileSuccess={() => {setReload(true)}} sideReload={reload} />
                            <AddNewFileToCase caseId={id} onNewFileSuccess={() => {setReload(true)}} />
                        </div>

                            <div className={styles.limitLine}></div>

                        <div className={styles.cardOfCaseLine}>
                            <h2>Дата и время создания карточки:</h2>
                            <a>{formatDateTime(caseInfo.created_at)}</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Начальная дата:</h2>
                            <a>{formatDate(caseInfo.date_start)}</a>
                            <a className={styles.description}>Установлена при создании карточки менеджером СОАУ</a>
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Текущая конечная дата:</h2>
                            <a>{formatDate(caseInfo.date_end)}</a>
                            {caseInfo.date_end && <a className={styles.description}>Сформирована на основе нынешнего этапа исполнения</a>}
                        </div>
                        <div className={styles.cardOfCaseLine}>
                            <h2>Статус:</h2>
                            <div className={styles.aWithImg}>
                                {caseInfo.status == "В работе" ? (
                                    <svg style={{width: '30px'}} viewBox="0 0 24 24" id="angle-right-b"><path fill="#6563FF" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path></svg>
                                ) : (
                                    <svg style={{width: '30px'}} viewBox="0 0 24 24" id="check"><path fill="#6563FF" d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"></path></svg>
                                )}
                                <a>{caseInfo.status}</a>
                            </div>
                        </div>

                            <div className={styles.limitLine}></div>
                        
                        <div className={styles.cardOfCaseLine}>
                            <h2>Действия:</h2>
                            <button type='button' className='button maxWidth' onClick={handleShareClick}>{shareButtonText}</button>
                            {access && 
                                <button 
                                    type='button' 
                                    className='button maxWidth black' 
                                    onClick={() => handleDeleteClick(caseInfo.id)}
                                >
                                    {confirmDelete ? "Вы уверены, что хотите удалить карточку?" : "Удалить"}
                                </button>
                            }
                        </div>
                    </>
                    ) : (
                        <>
                            <ChangeDataCase caseId={id} onChangeCaseDataSuccess={() => {setIsChangeData(false); setReload(true);}} />
                        </>
                    )
                )}
            </div>
            </form>
        </div>
    </>
    )
}

export default CardOfCase;